// extracted by mini-css-extract-plugin
module.exports = {"root":"FRzC7pU2OvHd","review":"L6eZ3FDIo1UI","icon":"TiCpBfpqxcTD"};